// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fL","catalogByServiceItem__title":"c-k_fM"};